// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";
import { useState } from "react";

import { mdiDotsVertical } from "@mdi/js";
import { Button, Popover, Tooltip } from "antd";

import { ActionListWrapper } from "..";
import { GeomBinEditAction } from "./actions";

interface IGeomBinActionsProps {
  isDisabled?: boolean;
  editGeomBin?: () => void;
}

/**
 * Essentially a wrapper for the geomBin actions, so that the actions can be used in different contexts.
 * @param params
 * @returns
 */
export function GeomBinActions(params: IGeomBinActionsProps): JSX.Element {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const actionList = (
    <ActionListWrapper>
      {params.editGeomBin && (
        <GeomBinEditAction
          closePopover={() => setIsPopoverOpen(false)}
          geomBinEditAction={params.editGeomBin}
        />
      )}
    </ActionListWrapper>
  );

  return (
    <Tooltip title="Actions">
      <Popover
        arrowPointAtCenter={true}
        content={actionList}
        onOpenChange={(isOpen) => {
          setIsPopoverOpen(isOpen);
        }}
        open={isPopoverOpen}
        overlayClassName="popover-no-padding"
        placement="bottomLeft"
        trigger="click">
        <Button type="text" className="geomBin-actions" aria-label="Edit">
          <Icon path={mdiDotsVertical} size={"21px"} />
        </Button>
      </Popover>
    </Tooltip>
  );
}
